import { PropertyConverter } from 'angular2-jsonapi'
import { Estabelecimento } from '../estabelecimento/estabelecimento.model'

export class EstabelecimentoConverter implements PropertyConverter {
    static toModel(obj: any): Estabelecimento {
        if (obj instanceof Estabelecimento) {
            return obj
        }

        const model = new Estabelecimento(null)

        model.id = obj.id
        model.situacao = obj.situacao
        model.numero = obj.numero
        model.carente = obj.carente
        model.possuiMovimentos = obj.possuiMovimentos
        model.totalDeTransacoes = obj.totalDeTransacoes
        model.ultimoExtrato = obj.ultimoExtrato
        model.codigoAcesso = obj.codigoAcesso
        model.token = obj.token
        model.utilizaApi = obj.utilizaApi
        model.dataInicial = obj.dataInicial
        model.agente = obj.agente
        model.empresa = obj.empresa
        model.dataCadastro = obj.dataCadastro
        model.dataInativacao = obj.dataInativacao
        model.status = obj.status

    // @Attribute() situacao: Situacao
    // @Attribute() numero: string
    // @Attribute() carente: boolean
    // @Attribute() possuiMovimentos: boolean
    // @Attribute() totalDeTransacoes: number
    // @Attribute({ converter: new LocalDateConverter() })
    // ultimoExtrato: Date
    // @Attribute() codigoAcesso: string
    // @Attribute() token: string
    // @Attribute() utilizaApi: boolean
    // @Attribute({ converter: new LocalDateConverter() })
    // dataInicial: Date
    // @Attribute({ converter: new LocalDateConverter() })
    // dataCadastro: Date
    // @Attribute({ converter: new LocalDateConverter() })
    // dataInativacao: Date
    // @Attribute() status: string
    // @BelongsTo() agente: Agente
    // @BelongsTo() empresa: EmpresaQueVendeComCartoes

        return model
    }

    static toJSON(model: Estabelecimento) {
        const json: any = Object.assign({}, model)

        return json
    }

    mask(value: any) {
        return EstabelecimentoConverter.toModel(value)
    }

    unmask(value: any) {
        return EstabelecimentoConverter.toJSON(value)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/converters/estabelecimentos.converter.ts